import { Showroom } from "./showroom";
import { MediaFile } from "./media";

export enum AccountType {
  Accounts = "Accounts",
  Admin = "Admin",
  BackendUser = "BackendUser",
  CallCenterExecutive = "CallCenterExecutive",
  CityHead = "CityHead",
  CommercialSurveyor = "CommercialSurveyor",
  ContentWriter = "ContentWriter",
  HRManager = "HRManager",
  LeadManager = "LeadManager",
  NationalHead = "NationalHead",
  "OfficeCo-oridnator" = "OfficeCo-oridnator",
  RegionalManager = "RegionalManager",
  SalesExecutive = "SalesExecutive",
  Telecaller = "Telecaller",
  Agent = "Agent",
  GroupManager = "GroupManager",
  IntercityUser = "IntercityUser",
}
export enum ModelNames {
  All = "All",
}

export interface OwnerUser {
  phone: string;
  name: string;
  _id?: string;
  avatar?: any;
  visbilityGroupId?: string;
  accountType?: AccountType;
  knownAs?: string;
  email?: string;
  employeeId?: string;
  photo?: any;
}

export interface OAuth2ClientOwner {
  name: string;
  _id?: string;
}

export interface User {
  _id?: string;
  name: string;
  email?: string;
  password?: string;
  phone?: string;
  avatar?: MediaFile;
  username?: string;
  contactName?: string;
  accountType?: AccountType;
  emails?: [
    {
      email?: string;
      emailType?: string;
      isPrimary?: true;
      isVerified?: true;
      unsubcribed?: true;
    }
  ];
  firstName?: string;
  lastName?: string;
  fullName?: string;
  knownAs?: string;
  firstLastName?: string;
  phones?: [
    {
      phone?: string;
      phoneType?: string;
      isPrimary?: true;
      whatsappNumber?: true;
      isVerified?: true;
    }
  ];
  role?: string;
  address?: {
    address: string;
    line1: string;
    line2: string;
    city: string;
    street: string;
    zip: string;
    state: string;
    country: string;
    region: string;
    block: string;
    building: string;
    area: string;
    postalCode: string;
    district: string;
    houseNumber: string;
    houseName: string;
    unitType: string;
    governorate: string;
    addressType: string;
  };
  showroomId?: string;
  franchiseId?: string;
  visibilityGroupId?: string;
  languages?: string[];
  drivingLicenses?: [
    {
      licenseType?: string;
      gearType?: string;
      licenseNumber?: string;
      licenseExpiryDate?: Date;
      licenseFrontImage?: string;
      licenseBackImage?: string;
    }
  ];
  employeeId?: string;
  alghanimEmployee?: boolean;
  nationality?: string;
  vehicleModels?: VehicleModels[];
  userId?: string;
  showroom?: {
    title: string;
    _id: string;
  };
  visibilityGroupTitle?: string;
  showroomIds?: string[];
  showrooms?: Showroom[];
  isBlocked?: boolean;
  syncEventToOutlook?: boolean;
  cities?: CityMinimal[];
  cityIds?: string[];
}

export interface CityMinimal {
  _id: string;
  cityName: string;
  value?: string;
  cityID?: number;
}

export interface VehicleModels {
  modelCode: string;
  variantCode: string;
}

export interface CreateUserShift {
  _id?: string;
  staffShiftId: string;
  fromDate: Date;
  showroomId?: string;
}

export interface UserShiftGrouped {
  upcoming: UserShift[];
  current: UserShift;
  past: UserShift[];
}

export interface UserShift {
  _id: string;
  staffShiftId: string;
  fromDate: string;
  userId: string;
  shiftName: string;
  showroomId: string;
  showroom: { _id: string; title: string };
  createdAt: Date;
  updatedAt: Date;
}

export interface UserTarget {
  _id: string;
  userId: string;
  year: string;
  month: string;
  target: number;
  createdBy?: OwnerUser;
  model?: { modelName: string; target: number }[];
}

export interface UserTargetDto {
  _id: string;
  month: string;
  target: number;
  model: string;
}
interface Timing {
  start: string;
  end: string;
}

export interface CreateTimeOff {
  _id?: string;
  timeOffType: string;
  startHalfDay: boolean;
  endHalfDay: boolean;
  fromDate: Date;
  toDate: Date;
  comments: string;
}

export interface UserTimeOffGrouped {
  upcoming: UserTimeOff[];
  current: UserTimeOff[];
  past: UserTimeOff[];
}

export interface UserTimeOff {
  _id: string;
  timeOffType: string;
  startDate: Date;
  endDate: Date;
  note: string;
  userId: string;
  createdAt: Date;
  updatedAt: Date;
}
